module.exports = __webpack_public_path__ + "media/images/flags/sm-551aef16c949cc9963ad74f8a62d9de8.svg";